import React, { useEffect, useState } from "react";
import ApexCharts from "apexcharts";
import jsonData from "../../../../current-survey-numeric.json"; // Ensure the path is correct

const D02PieChart1 = ({ filterCriteria }) => {
  const [favorableCount, setFavorableCount] = useState(0);
  const [neutralCount, setNeutralCount] = useState(0);
  const [unfavorableCount, setUnfavorableCount] = useState(0);
  const [noResponseCount, setNoResponseCount] = useState(0);

  // Update counts when filter criteria changes
  useEffect(() => {
    const filterData = (item) => {
      return Object.keys(filterCriteria).every((key) => {
        if (filterCriteria[key].length === 0) {
          return true; // If no filter is selected for this key, include all items
        }
        return filterCriteria[key].includes(item[key]);
      });
    };

    const filteredData = jsonData.filter(filterData);

    let favorable = 0;
    let neutral = 0;
    let unfavorable = 0;
    let noResponse = 0;

    // Use the same logic as in the first component, but for all four fields
    filteredData.forEach((response) => {
      const { MQ0026, MQ0095, MQ0302, MQ0321 } = response;
      
      // Process MQ0026 - this matches your first component's logic
      if (MQ0026 === 4 || MQ0026 === 5) {
        favorable++;
      } else if (MQ0026 === 3) {
        neutral++;
      } else if (MQ0026 === 1 || MQ0026 === 2) {
        unfavorable++;
      } else {
        noResponse++;
      }
      
      // If you need to process all four fields together with AND conditions,
      // you can use the more complex logic from your second component here instead
    });

    setFavorableCount(favorable);
    setNeutralCount(neutral);
    setUnfavorableCount(unfavorable);
    setNoResponseCount(noResponse);
  }, [filterCriteria]);

  // Create/update chart when counts change
  useEffect(() => {
    const optionsPie1 = {
      series: [favorableCount, neutralCount, unfavorableCount, noResponseCount],
      chart: {
        height: "300px",
        type: "pie",
        toolbar: {
          show: true,
        },
      },
      grid: {
        padding: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        },
      },
      plotOptions: {
        pie: {
          dataLabels: {
            offset: -8,
          },
        },
      },
      dataLabels: {
        enabled: true,
        style: {
          fontSize: "16px",
        },
      },
      labels: ["Favorable", "Neutral", "Unfavorable", "No Response"],
      colors: ["#499894", "#f1ce63", "#f28e2b", "#bab0ac"],
      legend: {
        position: "bottom",
      },
    };

    // Check if the chart element exists
    const chartElement = document.querySelector("#pie-1");
    if (!chartElement) return;

    const pie1 = new ApexCharts(chartElement, optionsPie1);
    pie1.render();

    // Clean up the chart on component unmount or state change
    return () => {
      pie1.destroy();
    };
  }, [favorableCount, neutralCount, unfavorableCount, noResponseCount]);

  return (
    <div>
      <div id="pie-1"></div>
    </div>
  );
};

export default D02PieChart1;